var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.52059 2.23528V2.18528L3.47059 2.18528L1 2.18529L0.95 2.18529V2.23529V8V8.05H1H6.76471H6.81471V8L6.81469 5.52941L6.81469 5.47941H6.76469H5.94118H5.89118V5.52941V7.12647H1.87353V3.10882L3.47059 3.10882H3.52059V3.05882V2.23528ZM8.05 1V0.95H8H4.70588H4.65588V1V1.82353V1.87353L4.70588 1.87353L6.47343 1.87352L3.14407 5.2029L3.10872 5.23825L3.14407 5.27361L3.72639 5.85593L3.76175 5.89128L3.79711 5.85593L7.12647 2.52653V4.29412V4.34412H7.17647H8H8.05V4.29412V1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.07db084c2d19be052d3f2b62b99146fa.svg";
export { ForwardRef as ReactComponent };